export default "__VITE_ASSET__CJIxzoZK__"